import { Link } from "react-router-dom";

import { AthleteFields } from "./AthleteFields";
import { formatAthleteScore } from "./AthleteUtil";
import { formatInteger } from "../../services/common/NumberUtil";
import AthleteAssignToMeButton from "./AthleteAssignToMeButton";
import AthleteSubscriptionButton from "./AthleteSubscriptionButton";
import GroupAddAthleteButton from "../group/GroupAddAthleteButton";

export const AthleteValues = ({ athlete, field, refetch, ...props }) => {
  switch (field) {
    case AthleteFields.fullname:
      return (
        <Link to={`/athletes/${athlete.id}`}>
          {athlete.firstname} {athlete.lastname}
        </Link>
      );
    case AthleteFields.fullname_no_link:
      return `${athlete.firstname} ${athlete.lastname}`;
    case AthleteFields.club:
      return (
        <Link to={`/clubs/${athlete.club?.id}`}>{athlete.club?.name}</Link>
      );
    case AthleteFields.club_no_link:
      return athlete.club?.name;
    case AthleteFields.category:
      return athlete.category;
    case AthleteFields.gender:
      if (athlete.gender === "m") {
        return "M";
      } else if (athlete.gender === "f") {
        return "F";
      } else {
        return "-";
      }
    case AthleteFields.dob:
      return athlete.dob;
    case AthleteFields.rank:
      return formatInteger(athlete._rank);
    case AthleteFields.score_general:
      return formatAthleteScore(athlete, "general");
    case AthleteFields.score_trail:
      return formatAthleteScore(athlete, "trail");
    case AthleteFields.score_cross:
      return formatAthleteScore(athlete, "cross");
    case AthleteFields.score_off_stadium:
      return formatAthleteScore(athlete, "off_stadium");
    case AthleteFields.department:
      return athlete.department;

    case AthleteFields.action_assign_to_user:
      return <AthleteAssignToMeButton athlete={athlete} />;
    case AthleteFields.action_subscribe:
      return <AthleteSubscriptionButton athlete={athlete} className="btn-sm" />;
    case AthleteFields.action_add_to_group:
      return (
        <GroupAddAthleteButton
          group_id={props.group_id}
          athlete_id={athlete.id}
          className="btn-sm"
          refetch={refetch}
        />
      );
    default:
      return null;
  }
};
